import Reporte from './reporte'
import Grafico from './grafico'

export default {
  '/factura/grafico': () => <Grafico />,
  '/factura/reporte': () => <Reporte />
}
